import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { getConsent, setConsent } from '../utils/consent';
import { enableAnalytics } from '../firebase';

// Consent banner: Google Analytics stays off until "Accept all" (see
// src/firebase.js); "Essential only" keeps just the cookies sign-in needs.
export default function CookieBanner() {
  const [visible, setVisible] = useState(() => getConsent() === null);

  if (!visible) return null;

  function choose(value) {
    setConsent(value);
    if (value === 'all') enableAnalytics();
    setVisible(false);
  }

  return (
    <div
      role="region"
      aria-label="Cookie notice"
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 300,
        background: 'var(--bg-card)',
        borderTop: '1px solid var(--border-light)',
        boxShadow: '0 -4px 20px rgba(52, 45, 37, 0.10)',
        padding: 'calc(var(--space-md)) var(--space-lg)',
        paddingBottom: 'calc(var(--space-md) + env(safe-area-inset-bottom, 0px))',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 'var(--space-md)',
        fontSize: '0.85rem',
        color: 'var(--text-secondary)'
      }}
    >
      <span style={{ maxWidth: 640, lineHeight: 1.5, textAlign: 'center' }}>
        We use essential cookies to keep you signed in, and optional
        analytics cookies to understand how Tastr is used. We{' '}
        <strong>highly recommend</strong> accepting all cookies to maximize your
        experience. For more information, please see our{' '}
        <Link to="/privacy" style={{ color: 'var(--green-600)', fontWeight: 600, textDecoration: 'underline' }}>
          Privacy Policy
        </Link>.
      </span>
      <span style={{ display: 'flex', gap: 'var(--space-sm)', flexShrink: 0 }}>
        <button className="btn btn-secondary btn-sm" onClick={() => choose('essential')}>
          Essential only
        </button>
        <button className="btn btn-primary btn-sm" onClick={() => choose('all')}>
          Accept all
        </button>
      </span>
    </div>
  );
}
